import fetchJsonp from 'fetch-jsonp';
export default function callApi(method: string, url: string, path: string, data?: any) {
  return fetch(url + '/api' + path, {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(res => res.json())
}

export function flickrAPIx(method: string, url: string, data?: any) {
  console.log(arguments)
  return fetchJsonp(url, {
    method: "get",
    dataType:'jsonp',
    headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
    // body: JSON.stringify(data)
  }).then(res => res.json())
}
export function flickrAPI() {
  'https://api.flickr.com/services/feeds/photos_public.gne?format=json&nojsoncallback=1&per_page=9&tags=Porsche', {
headers: {
'Accept' : 'application/json',
'Content-Type' : 'application/json'
},
mode: 'no-cors',
})
.then(data => {
return data.json();
})
}
// }
// url: ,
//     dataType: 'jsonp',
//     data: { "tags": "kitten", "format": "json" }
//   });